<template>
	<div class="gral-container">
    <form>
      <!-- Basic Filters -->
      <b-form-row>
        <b-form-group class="col-md-3"  label="Criterio Fechas">
          <b-form-select 
            size="sm" 
            v-model="filters.dateCriteria" 
            :options="optionsCriteriaDates">
          </b-form-select>
        </b-form-group>

        <b-form-group class="col-md-3" label="Criterio de consulta">
          <b-form-select 
            size="sm" 
            v-model="filters.sourceCriteria" 
            :options="optionsSource">
          </b-form-select>
        </b-form-group>

        <b-form-group class="col-md-6" label="Filtrar zona maestra" 
          v-if="filters.sourceCriteria == 'destinations'">
          <multiselect v-model="filters.zonesSelected"
            :options="zonesOptions"
            :multiple="true"
            placeholder="Type to search"
            track-by="value"
            label="text">
            <span slot="noResult">Oops! No se encontraron resultados.</span>
              <template v-slot:clear >
                <div class="multiselect__clear" @click="filters.zonesSelected = []"></div>
              </template>
          </multiselect>
          <div class="text-danger" v-if="destinationsRequired">
            Debes seleccionar al menos un destino**
          </div>
        </b-form-group>

      </b-form-row>

      <!-- Second row filters -->
      <b-form-row>
        <!-- Range of years selects -->
        <b-form-group 
          class="col-md-3" 
          label="Año de inicio *" 
          v-if="filters.timeGroup == 'per-year' || filters.timeGroup == 'per-month'">
          <b-form-select 
            size="sm" 
            v-model="filters.startDate"
            :options="optionsYears">
          </b-form-select>
        </b-form-group>

        <b-form-group 
          class="col-md-3" 
          label="Hasta el año *" 
          v-if="filters.timeGroup == 'per-year' || filters.timeGroup == 'per-month'">
          <b-form-select 
            size="sm" 
            v-model="filters.endDate" 
            :options="optionsYears">
          </b-form-select>
        </b-form-group>
        <!-- End range of years selects -->

        <b-form-group 
          class="col-md-3" 
          label="Fecha desde *" 
          v-if="filters.timeGroup != 'per-year' && filters.timeGroup != 'per-month'">
          <b-form-datepicker 
              locale="es" 
              :class="{'active-filter':filters.startDate}" 
              reset-button size="sm" 
              v-model="filters.startDate"/>
        </b-form-group>

        <b-form-group 
          class="col-md-3" 
          label="Hasta *" 
          v-if="filters.timeGroup != 'per-year' && filters.timeGroup != 'per-month'">
          <b-form-datepicker 
            locale="es" 
            :class="{'active-filter':filters.endDate}" 
            reset-button  
            size="sm" 
            v-model="filters.endDate"/>
        </b-form-group>

        <b-form-group class="col-md-3 text-center" label="Agrupar por">
          <b-form-radio-group
            id="btn-radios-1"
            v-model="filters.timeGroup"
            :options="optionsRadio"
            buttons
            @change="handleRadioChange"
            name="radios-btn-default">
          </b-form-radio-group>
        </b-form-group>

        <b-form-group class="col-md-3 table-responsive" label="">
          <br>
          <b-button 
            variant="warning" 
            v-b-toggle="'advanced-filters'" 
            class="btn mr-2" 
            id="advanced-filters">
            <md-icon icon="filter_list"/>
          </b-button>
          <b-tooltip 
            target="advanced-filters" 
            triggers="hover">
            Mostrar/Ocultar Filtros avanzados
          </b-tooltip>
          <b-button 
            variant="outline-primary" 
            type="button" 
            @click="checkform()">
            <md-icon icon="search"/>
          </b-button>
        </b-form-group>
      </b-form-row>

      <b-form-row v-if="filters.timeGroup == 'per-week'">
        <b-form-group class="text-info">
          <small>
            En agrupación por semana se contempla hasta la fecha indicada, por lo que podrían considerarse semanas incompletas.
          </small>
        </b-form-group>
      </b-form-row>
      <!-- End basic filters -->

      <!-- Advanced filters -->
      <b-collapse id="advanced-filters">
        <b-form-row>
          <!-- Range of months selects -->
          <b-form-group 
            class="col-md-2" 
            label="Mes de inicio" 
            v-if="filters.timeGroup == 'per-year' || filters.timeGroup == 'per-month'">
            <b-form-select 
              size="sm" 
              v-model="filters.startMonth" 
              :options="optionsMonths">
            </b-form-select>
          </b-form-group>

          <b-form-group 
              class="col-md-2" 
              label="Hasta el mes" 
              v-if="filters.timeGroup == 'per-year' || filters.timeGroup == 'per-month'">
              <b-form-select 
              size="sm" 
              v-model="filters.endMonth" 
              :options="optionsMonths">
              </b-form-select>
          </b-form-group>
          <!-- End range of months selects -->

          <!-- Days of week -->
          <b-form-group class="col-md-6" label="Filtrar por dias de la semana:">
              <b-form-checkbox-group
              id="days-of-week"
              class="border p-1"
              v-model="filters.daysSelected"
              :options="optionsDays">
              </b-form-checkbox-group>
          </b-form-group>
          <!-- End days of week -->

          <!-- Filter by service date or reservation date -->
          <b-form-group 
            class="col-md-3" 
            :label="secondFilterStart" >
            <b-form-datepicker 
              locale="es"
              :class="{'active-filter':filters.secondStartDate}" 
              reset-button
              size="sm"
              v-model="filters.secondStartDate"/>
          </b-form-group>

          <b-form-group 
            class="col-md-3" 
            :label="secondFilterEnd" >
            <b-form-datepicker 
              locale="es" 
              :class="{'active-filter':filters.secondFilterEnd}" 
              reset-button
              size="sm"
              v-model="filters.secondEndDate"/>
          </b-form-group>


          <b-form-group class="col-lg-4" label="Estado de servicio">
              <multiselect
              v-model="filters.status"
              :options="statusOpts"
              group-label="group"
              group-values="options"
              group-select
              multiple
              label="text"
              track-by="value"
              placeholder="Todos"
              taggable>
              <template v-slot:clear >
                  <div 
                  class="multiselect__clear" 
                  @click="filters.status = []">
                  </div>
              </template>
              </multiselect>
          </b-form-group>

          <b-form-group class="col-lg-4 mt-0" label="Canal de venta">
              <GroupedSalesChannelsSelect
                  v-model="filters.salesChannels"
                  placeholder="Todos"
              />
          </b-form-group>

          <b-form-group class="col-lg-4 mt-0" label="Puntos de venta">
              <multiselect
              :class="{'active-filter':filters.pointOfSales.length>0}"
              v-model="filters.pointOfSales"
              :options="pointOfSalesOpts"
              multiple
              label="text"
              placeholder="Todos"
              taggable
              track-by="value">
              <template v-slot:clear >
                  <div class="multiselect__clear" @click="filters.pointOfSales = []">
                  </div>
              </template>
            </multiselect>

          </b-form-group>

          <b-form-group class="col-lg-4" label="Proveedor">
              <multiselect
              v-model="filters.suppliers"
              :options="suppliersOpts"
              group-label="group"
              group-values="options"
              group-select
              multiple
              label="text"
              track-by="value"
              placeholder="Todos"
              taggable>
              <template v-slot:clear >
                  <div class="multiselect__clear" @click="filters.suppliers = []">
                  </div>
              </template>
              </multiselect>
          </b-form-group>

          <b-form-group class="col-lg-6" label="Zonas Master">
              <multiselect v-model="filters.zones"
              :options="zonedAreasGroupedOpts"
              :multiple="true"
              group-values="zones"
              group-label="zonedArea"
              :group-select="true"
              placeholder="Type to search"
              track-by="text"
              label="text">
                  <span slot="noResult">Oops! No se encontraron resultados.</span>
                  <template v-slot:clear >
                  <div class="multiselect__clear" @click="filters.zones = []"></div>
                  </template>
                  <template slot="option" slot-scope="props">
                  <div class="option__desc" v-if="props.option.$groupLabel">
                      <span class="option__title">{{ props.option.$groupLabel }}</span><br>
                  </div>
                  <div class="option__desc"  v-else>
                      <span class="option__title">{{ props.option.text }}</span><br>
                      <small class="option__small text-muted">
                          {{ props.option.zonedAreaName }}
                      </small>
                  </div>
                  </template>
                  <template slot="option-group" slot-scope="props">
                  <div class="option__desc">
                      <span class="option__title">{{ props.option.text }}</span><br>
                      <small class="option__small text-muted">
                      {{ props.option.zonedAreaName }}
                      </small>
                  </div>
                  </template>
              </multiselect>
          </b-form-group>

        </b-form-row>

        <b-form-row>
          <b-form-group
              v-if="$hasPermission('filters.trip')"
              class="col-lg-1"
              label="Viaje">
              <b-form-select
              :class="{ 'active-filter': filters.trip }"
              v-model="filters.trip"
              :options="tripOpts"/>
          </b-form-group>

          <b-form-group class="col-lg-2" label="Pagos">
              <b-form-select 
              v-model="filters.payments" 
              :options="optionsPayments">
              </b-form-select>
          </b-form-group>

          <b-form-group class="col-lg-4" label="Escalar cantidades">
              <b-form-checkbox v-model="scale" name="check-button" switch class="pt-2">
              Formato de cantidades en <strong>1M</strong>, <strong>100k</strong>
              </b-form-checkbox>
          </b-form-group>
        </b-form-row>
      </b-collapse>
    <!-- End advanced filters -->
    </form>

    <b-row>
      <!-- Loading -->
      <div v-if="loading" class="col-12 text-center pt-5">
          <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
          <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
          <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
      </div>
      <!-- End Loading -->
	
			<b-col class="col-md-12 mt-4" v-if="!loading">

        <div>
          <b-button
            class="float-right mb-2"
            variant="primary"
            @click="() => $refs['table-columns'].show()"
            ><md-icon icon="settings"/>
          </b-button>
        </div>

				<div class="table-responsive async-tables mt-3 text-center" v-if="showHtmlTable">
					<b-table
            id="spit-main-table"
            show-empty
            hover
            small
            bordered
            stacked-sm
            responsive
            :items="table.body" 
            :fields="selectedColumnsObjs"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            selectable
            select-mode="multi"
            @row-clicked="item=>onRowSelected(item)">

            <!-- A virtual column -->
            <template #cell(index)="data">
                <div class="text-right">
                    <md-icon 
                    icon="star"
                    class="text-warning font-weight-bolder"
                    style="font-size: 12px; padding-bottom: 2px;"
                    v-if="data.item.star == true"/>

                    <a v-if="data.item.row_data.type != '_source'" 
                      href="#" @click="showComparativeModal(data)">
                      {{ data.item.name }}
                    </a>
                    <span v-else>{{ data.item.name }}</span>
                    
                    <template v-if="data.rowSelected">
                        <md-icon 
                        icon="keyboard_arrow_down"
                        class="font-weight-bolder"/>
                    </template>

                    <template v-else>
                        <md-icon 
                        icon="keyboard_arrow_right"
                        class="font-weight-bolder"/>
                    </template>
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(spit_rides)="data">
                <div class="text-right">
                  {{  number_format(data.item.spit_rides,0,'.',',') }}
                <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.spit_rides > data.item.last_year_spit_rides"/>
                <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(last_year_spit_rides)="data">
                <div class="text-right">
                {{ number_format(data.item.last_year_spit_rides,0,'.',',') }}
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(rides)="data">
                <div class="text-right">
                <a href="#" @click="showTimeLineModal(data)">
                  {{ number_format(data.item.rides,0,'.',',') }}
                </a>
                <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.rides > data.item.last_year_rides"/>
                <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(last_year_rides)="data">
                <div class="text-right">
                {{ number_format(data.item.last_year_rides,0,'.',',') }}
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(spit_total)="data">
                <div class="text-right">
                <span v-b-tooltip.hover :title=data.item.spit_total>
                    ${{ formatNumberString(data.item.spit_total) }}
                </span>
                <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.spit_total > data.item.last_year_spit_total"/>
                <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(last_year_spit_total)="data">
                <div class="text-right">
                <span v-b-tooltip.hover :title=data.item.last_year_spit_total>
                    ${{ formatNumberString(data.item.last_year_spit_total) }}
                </span>
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(total)="data">
                <div class="text-right">
                <span v-b-tooltip.hover :title=data.item.total>
                    ${{ formatNumberString(data.item.total) }}
                </span>
                <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.total > data.item.last_year_total"/>
                <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(last_year_total)="data">
                <div class="text-right">
                <span v-b-tooltip.hover :title=data.item.last_year_total>
                    ${{ formatNumberString(data.item.last_year_total) }}
                </span>
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(supplier_cost)="data">
                <div class="text-right">
                <span v-b-tooltip.hover :title=data.item.supplier_cost>
                    ${{ formatNumberString(data.item.supplier_cost) }}
                </span>
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(profit)="data">
                <div class="text-right">
                <span v-b-tooltip.hover :title=data.item.profit>
                    ${{ formatNumberString(data.item.profit) }}
                </span>
                <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.profit > data.item.last_year_profit"/>
                <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
            </template>

            <!-- A virtual column -->
            <template #cell(margin_profit)="data">
                <div class="text-right">
                <span v-b-tooltip.hover :title=data.item.margin_profit 
                :class="getTextColorPercentage(data.item.margin_profit)">
                    {{ (data.item.margin_profit) }}%
                </span>
                </div>
            </template>

            <template #row-details="row">
              <div class="ml-2">
                <TableDeep 
                  :ref="'table'+row.item.index" 
                  :scale="scale" 
                  :columns="selectedColumns"
                  @show-time-line="showTimeLine"
                  @show-comparative="showComparativeModal"
                  >
                </TableDeep>
              </div>
            </template>
					</b-table>
				</div>
			</b-col>
		</b-row>

    <b-modal
			title="Columnas de tabla"
			ref="table-columns"
			hide-footer
			ok-title="Guardar"
			size="md"
		>
			<b-form-checkbox-group
				stacked
				v-model="selectedColumns"
				:options="table.header"
				text-field="label"
				value-field="key"
			/>
		</b-modal>

    <b-modal ref="modal-timeLine" size="xl" title="Linea de tiempo de servicios">
      <div v-if="loadingRidesTimeLine" class="col-12 text-center pt-5">
				<b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
			</div>
      <b-row v-else>
        <b-col>
          <b-form-row>
            <b-form-group 
              class="col-md-2" 
              label="Agrupar grafica por:">
              <b-form-select 
                size="sm" 
                v-model="timeLineGroup" 
                :options="optionsTimeLineGroups">
              </b-form-select>
              <small class="text-primary">Limitado a 12 meses*</small>
            </b-form-group>
            <b-form-group 
              class="col-md-2 mt-4">
              <!-- Reload chart with new agrupation -->
              <b-button size="sm" variant="info" @click="showTimeLineModal(dataTimeLineSelected)">
                Consultar
              </b-button>
            </b-form-group>
          </b-form-row>
          <TimeLineChart :data="chartData"></TimeLineChart>
        </b-col>
      </b-row>

      <template #modal-footer="{ ok }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="info" @click="ok()">OK</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-comparative" ref="modal-comparative" size="xl" title="Comparar periodos de tiempo">
      <Comparative :filters="filtersComparative" :data="dataComparativeSelected" v-if="dataComparativeSelected != null"/>
      <template #modal-footer="{ ok }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="info" @click="ok()">OK</b-button>
      </template>
    </b-modal>
    
  </div>
</template>
<script>
  import moment from 'moment'
  import Multiselect from 'vue-multiselect';
  import GroupedSalesChannelsSelect from '../../../helpers/GroupedSalesChannelsSelect';
  import TableDeep from './Table.vue'
  import api from "../../../../api.js";
  import TimeLineChart from "./TimeLineChart.vue"
  import Comparative from './Comparative.vue';

  export default {
    name: "SPIT",
    components:{ Multiselect, GroupedSalesChannelsSelect, TableDeep, TimeLineChart, Comparative },
    data() {

      let start = moment().startOf('month').format('YYYY-MM-DD');
      let end   = moment().format('YYYY-MM-DD');

      return {
        loading: false,
        loadingRidesTimeLine: false,
        codeReport: 'spit-revenue',
        showHtmlTable: true,
        scale: true, // formatear numeros a numeros mas pequeños
        selectedColumns: [],
        filters: {
          dateCriteria: 'service-date',
          startDate: start,
          endDate: end,
          startMonth: 0,
          endMonth: 0,
          timeGroup: 'per-day',
          salesChannels: [],
          pointOfSales: [],
          suppliers: [],
          zones: [],
          zonesApto: [],
          zonesSelected: [],
          status: [
            {value:"active", text:"Activo",    class:"default"},
            {value:"done",   text:"Realizado", class:"success"},
            {value:"noShow", text:"No show",   class:"info"}
          ],
          payments: 'all',
          daysSelected:[],
          secondStartDate: null,
          secondEndDate: null,
          trip: 0,
          sourceCriteria: 'sales_channels',
          row_data: null,
        },
        sortBy: 'index',
        sortDesc: true,
        table: {
          header: [
            {
              key: 'index',
              label: 'Periodo',
              sortable: true
            },
            {
              key: 'spit_rides',
              label: 'SPIT Rides',
              sortable: true,
              variant: 'info'
            },
            {
              key: 'last_year_spit_rides',
              label: 'SPIT Rides P.A.',
              sortable: true,
              variant: 'info'
            },
            {
              key: 'rides',
              label: 'Rides',
              sortable: true,
              variant: 'info'
            },
            {
              key: 'last_year_rides',
              label: 'Rides P.A.',
              sortable: true,
              variant: 'info'
            },
            {
              key: 'spit_total',
              label: 'SPIT Total',
              sortable: true,
              variant: 'warning'
            },
            {
              key: 'last_year_spit_total',
              label: 'SPIT Total P.A',
              sortable: true,
              variant: 'warning'
            },
            {
              key: 'total',
              label: 'Total',
              sortable: true,
              variant: 'warning'
            },
            {
              key: 'last_year_total',
              label: 'Total P.A.',
              sortable: true,
              variant: 'warning'
            },
            
            {
              key: 'supplier_cost',
              label: 'Proveedor',
              sortable: true,
              variant: 'primary'
            },
            {
              key: 'profit',
              label: 'Ganancia',
              sortable: true,
              variant: 'success'
            },
            {
              key: 'margin_profit',
              label: 'Margen',
              sortable: true
            },
          ],
          body: []
        },
        items: [],
        selected:'per-year',
        chartData: [],
        timeLineGroup: 'month',
        dataTimeLineSelected: null,
        filtersComparative: {},
        dataComparativeSelected: null,
        destinationsRequired: false,
        comparativeData: [],
        optionsSource:[
          { text: 'Canales de venta', value: 'sales_channels' },
          { text: 'Puntos de venta', value: 'points_of_sales' },
          { text: 'Proveedor', value: 'suppliers' },
          { text: 'Destinos', value: 'destinations' }
        ],
        optionsRadio:[
          { text: 'Año', value: 'per-year' },
          { text: 'Mes', value: 'per-month' },
          { text: 'Semana', value: 'per-week' },
          { text: 'Dia', value: 'per-day' },
        ],
        optionsCriteriaDates:[
        { text: 'Por fecha de servicio', value: 'service-date'},
          { text: 'Por fecha de reserva', value: 'reservation-date' }
        ],
        optionsPayments: [
          {text: 'Todos los rides', value: 'all'},
          {text: 'Rides con pagos', value: 'withPayments'},
          {text: 'Rides sin pagos', value: 'withoutPayments'}
        ]
      }
    },
    methods:{
      onRowSelected(item) {
        this.$set(item, '_showDetails', !item._showDetails)
        this.$nextTick(() => {
          if (item._showDetails) {
            const childComponent = this.$refs['table'+item.index];
            if (childComponent) {
              this.filters.row_data = item.row_data
              childComponent.loadTable(this.filters, this.scale);
            } else {
              console.error('Table Child component reference is undefined.');
            }  
          }
        })
      },
      number_format (number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
        prec  = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep   = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec   = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s     = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
        
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
          s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }

        if ((s[1] || '').length < prec) {
          s[1] = s[1] || '';
          s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
      },
      checkform(){
        let errors = [];
        if(this.filters.startDate ==="" || this.filters.endDate === ""){
          errors.push("Fecha inicio y fecha fin son requeridos");
        }
        if(this.filters.dateCriteria ===""){
          errors.push("Criterio fechas es requerido");
        }
        if(errors.length===0){
          this.search();
        }else{
          this.$root.showAlert(errors[0],{variant:'warning'});
        }
      },
      search(){
      
        this.destinationsRequired = false
        if (this.filters.sourceCriteria == 'destinations' 
          && this.filters.zonesSelected.length == 0) {
            this.destinationsRequired = true
            return false
        }

        this.loading              = true
        this.showHtmlTable        = false;
        this.table.body           = []
        this.filters.row_data     = null

        api(this)
          .get(`/reports/${this.codeReport}`, {
            params: {
              filters: this.filters
            }
          })
          .then(res => {

            this.showHtmlTable = true;
            const data = res.data.body;

            let body = []
            for (const group in data) {
              body.push(data[group])
            }
            
            this.table.body = body
          })
          .catch(error => {
            this.$root.handleRequestError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      getTextColorPercentage(quantity) {
        let variant = ''
        if (quantity >= 20) {
          variant = 'text-success font-weight-bold'
        } else {
          variant = 'text-warning font-weight-bold'
        }

        return variant + ' text-right'
      },
      formatNumberString(number) {
        if (this.scale == true) {
          /** 1 M */
          const scaleMillions = 1000000
          if (number >= scaleMillions) {
            number = this.number_format((number/scaleMillions),2,'.',',');
            return number + " M";
          }
          /** 100 K */
          const scaleThousands = 1000
          if (number >= 100000) {
            number = this.number_format((number/scaleThousands),2,'.',',');
            return number + " K";
          }
        }

        return this.number_format(number,2,'.',',');
      },
      handleRadioChange() {
        if (this.filters.timeGroup == 'per-year' || this.filters.timeGroup == 'per-month') {
          this.filters.startDate = moment().format("YYYY");
          this.filters.endDate   = moment().format("YYYY");
        }

        if (this.filters.timeGroup == 'per-week' || this.filters.timeGroup == 'per-day') {
          this.filters.startDate = moment().startOf('month').format('YYYY-MM-DD');
          this.filters.endDate   = moment().format('YYYY-MM-DD');
        }
      },
      loadUserPreferences() {
        this.selectedColumns = this.table.header.map(col => col.key);
        try {
          let tableColumns = JSON.parse(
            sessionStorage.getItem(`table-${this.$el.id}-columns`)
          );
          if (tableColumns !== null) this.selectedColumns = tableColumns;
        } catch (e) {
          sessionStorage.removeItem(`table-${this.$el.id}-columns`);
        }
      },
      showTimeLineModal(data) {
        this.$refs['modal-timeLine'].show()
        this.loadingRidesTimeLine = true

        let filters = {...this.filters}
        filters.row_data = data.item.row_data
        filters.chart    = 'timeLine'
        filters.column   = data.field
        filters.groupBy  = this.timeLineGroup

        this.dataTimeLineSelected = data

          api(this)
          .get(`/spit/timeline/comparative`, {
              params: {filters}
            })
          .then(res => {
            this.chartData = res.data
          })
          .catch(error => {
            this.$root.handleRequestError(error);
          })
          .finally(() => {
            this.loadingRidesTimeLine = false;
          });
          

      },
      showTimeLine(data) {
        this.showTimeLineModal(data)
      },
      showComparativeModal(data) {

        let filters      = {...this.filters}
        filters.row_data = data.item.row_data
        filters.chart    = 'comparative'
        filters.column   = data.field
        filters.groupBy  = this.timeLineGroup

        this.filtersComparative      = filters
        this.dataComparativeSelected = data.item
        this.$refs['modal-comparative'].show()
      }
    },
    mounted(){
      this.$root.auxVars.loadResourcesOpts({
        vm: this, 
        resourceNames: [
          'salesChannelsOpts',
          'masterZonedAreasOpts',
          'suppliersOpts',
          'transportServiceStatusOpts'
        ]
      }),
      this.loadUserPreferences()
    },
    computed:{
      zonedAreasGroupedOpts(){
				let grouped = [];
				this.$root.auxVars.masterZonedAreasOpts.forEach((ele)=>{
					let item = {
						zonedArea:ele.name,
						zones:ele.zones.map((aux)=>({value:aux.id,text:aux.name,zonedAreaName:ele.name}))
					};
					grouped.push(item)
				})
        return grouped
			},
      pointOfSalesOpts() {
        let aux = [...this.$root.auxVars.pointOfSalesOpts.map((pos) => ({
          value: pos.id,
          text: pos.codename,
        }))];
        return aux;
      },
      zonesOptions() {
        let aux= [...this.$root.auxVars.masterZonedAreasOpts.map((zam) => ({
          value: zam.id,
          text: zam.name,
        }))];
        return aux;

      },
      suppliersOpts(){
        return [
          {
            group: "SELECT ALL",
            options: this.$root.auxVars.suppliersOpts.map((sp) => ({
              value: sp.id,
              text: sp.code
            }))
          }
        ];
      },
      statusOpts() {
        return [
          {
            group: "SELECT ALL",
            options: this.$root.auxVars.transportServiceStatusOpts
          }
        ];
      },
      tripOpts() {
        let aux = [...this.$root.auxVars.tripOpts];
        aux.unshift({ value: 0, text: "Todos" });
        return aux;
      },
      optionsYears() {

        const startYear = 2020
        const limit     = moment().add(3, 'y').format('YYYY')
        
        let optionsYears = []
        for (let index = limit; index >= (startYear); index--) {
          optionsYears.push(index)
        }
        
        return optionsYears
      },
      optionsMonths() {
        return [
          {value:0 , text:"Todos"},
          {value:1 , text:"Enero"},
          {value:2 , text:"Febrero"},
          {value:3 , text:"Marzo"},
          {value:4 , text:"Abril"},
          {value:5 , text:"Mayo"},
          {value:6 , text:"Junio"},
          {value:7 , text:"Julio"},
          {value:8 , text:"Agosto"},
          {value:9 , text:"Septiembre"},
          {value:10, text:"Octubre"},
          {value:11, text:"Noviembre"},
          {value:12, text:"Diciembre"},
        ]
      },
      optionsDays() {
        return [
          {value:1 , text:"Lun"},
          {value:2 , text:"Mar"},
          {value:3 , text:"Mié"},
          {value:4 , text:"Jue"},
          {value:5 , text:"Vie"},
          {value:6 , text:"Sáb"},
          {value:7 , text:"Dom"},
        ]
      },
      secondFilterStart() {
        if (this.filters.dateCriteria == 'service-date') {
          return 'Fecha de reservación desde: '
        } else {
          return 'Fecha de servicio desde:'
        }
      },
      secondFilterEnd() {
        if (this.filters.dateCriteria == 'service-date') {
          return 'Fecha de reservación hasta: '
        } else {
          return 'Fecha de servicio hasta:'
        }
      },
      selectedColumnsObjs() {
        return this.table.header.filter(
          column => this.selectedColumns.indexOf(column.key) !== -1
        );
      },
      optionsTimeLineGroups() {
        return [
          {value: 'month', text: 'Mes'}, 
          {value: 'week', text: 'Semana'}, 
          {value: 'day', text: 'Dia'}
        ]
      }
    },
    watch: {
      selectedColumns(val) {
        sessionStorage.setItem(
          `table-${this.$el.id}-columns`,
          JSON.stringify(val)
        );
      }
    }
  }
</script>

<style>
	
  #modal-comparative .modal-dialog {
		width: 96% !important;
		max-width: inherit;
	}

	@media (min-width: 1200px){
		#modal-comparative .modal-dialog{
			max-width: 1300px;
		}
		.table{
			font-size: .85rem;
		}
	}
</style>